import { render, staticRenderFns } from "./comparison.vue?vue&type=template&id=7c80e67a&"
import script from "./comparison.vue?vue&type=script&lang=ts&"
export * from "./comparison.vue?vue&type=script&lang=ts&"
import style0 from "./comparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports